import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import MenuArrowSvg from "../../assets/menu_arrow.svg?react";
import { CONTACT_SECTION_ID, PAGE_NAV_ITEMS } from "./Header.config";
import type { HeaderNavSharedProps } from "./HeaderNav.types";
import {
  getMobileNavDividerSx,
  getMobileNavIconSx,
  getMobileNavLabelSx,
  getMobileNavOverlaySx,
  mobileNavSectionButtonSx,
} from "./Header.sx";

export function MobileNav({
  isDarkMode,
  activeSection,
  isPageNavItemActive,
  onPageClick,
  onContactClick,
}: HeaderNavSharedProps) {
  return (
    <Stack
      display={{ xs: "flex", sm: "none" }}
      direction="column"
      justifyContent="space-around"
      alignItems="stretch"
      sx={getMobileNavOverlaySx(isDarkMode)}
      divider={<Divider sx={getMobileNavDividerSx(isDarkMode)} />}
    >
      {PAGE_NAV_ITEMS.map((item) => {
        const isActive = isPageNavItemActive(item.path);
        return (
          <Box
            key={item.path}
            component="button"
            onClick={() => onPageClick(item.path)}
            sx={mobileNavSectionButtonSx}
          >
            <Stack direction="row" alignItems="center" gap="1rem">
              <SvgIcon
                component={MenuArrowSvg}
                inheritViewBox
                sx={getMobileNavIconSx(isActive, isDarkMode)}
              />
              <Typography sx={getMobileNavLabelSx(isActive, isDarkMode)}>
                {item.label}
              </Typography>
            </Stack>
          </Box>
        );
      })}
      <Box
        component="button"
        onClick={onContactClick}
        sx={mobileNavSectionButtonSx}
      >
        <Stack direction="row" alignItems="center" gap="1rem">
          <SvgIcon
            component={MenuArrowSvg}
            inheritViewBox
            sx={getMobileNavIconSx(activeSection === CONTACT_SECTION_ID, isDarkMode)}
          />
          <Typography
            sx={getMobileNavLabelSx(activeSection === CONTACT_SECTION_ID, isDarkMode)}
          >
            Contact
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
}
